import React from 'react';
import { Container } from '../../SharedStyles/SharedStyles';
import { FooterCont, A } from './Styles';

const Footer = () => {
    return (
        <Container>
            {/* </FooterLink> */}
            <FooterCont>
               
            </FooterCont>
            {/* </FooterLink> */}
        </Container>
    );
};

export default Footer;
